import { ref } from 'vue';

const isCardApproved = ref(false);
const setIsCardApproved = (value: boolean) => {
  isCardApproved.value = value;
};

export function useIsCardApproved() {
  return { isCardApproved, setIsCardApproved };
}
